export const FETCH_LISTS = '@@firedrum/FETCH_LISTS'
export const FETCHING_LISTS = '@@firedrum/FETCHING_LISTS'
export const SET_LISTS = '@@firedrum/SET_LISTS'
